module.exports = __webpack_public_path__ + "img/exit_1.4d0075f2.png";